import { render, staticRenderFns } from "./HeaderAdmin.vue?vue&type=template&id=5af28ee0&"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js&"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports